<div class="animated fast fadeIn">
  <!-- Header -->
  <header class="masthead parallax">
    <div class="container">
      <div class="intro-text">
        <div class="intro-lead-in"> Desarrollador </div>
        <div class="intro-heading text-uppercase">Gustavo Andrés López Sánchezs</div>
        <div id="btn-intro" class="circulo-intro">
          <a id="flecha" class="btn-xl text-uppercase js-scroll-trigger" [pageScrollDuration]="300" [pageScrollOffset]="52" pageScroll [routerLink]="['/']" href="#skillsAndCompetences">
            <span  class="icon-flechas"></span>
          </a>
        </div>
      </div>
    </div>
  </header>

  <!-- Skils and competences -->
  <section id="skillsAndCompetences" #skillsAndCompetences>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Habilidades y competencias</h2>
          <!-- <h3 class="section-subheading text-muted">Frontend</h3> -->
        </div>
      </div>
      <div class="row text-center">
        <div class="col-6 col-md-3" *ngFor="let skill of skills">
          <a style="cursor:pointer;">
            <span class="circulo text-center">
              <i class="{{skill.icon}} ico-center"></i>
            </span>
          </a>
          <h4 class="service-heading">{{ skill.name }}</h4>
         <p class="text-muted">{{ skill.desc }}</p>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" style="padding-top: 20px;" >
            <a class="btn btn-success btn-lg" [routerLink]="['/servicios']"  >Visita nuestro catálogo</a>
        </div>
      </div> -->
    </div>
  </section>

  <!-- banner-publicidad -->
  <!--
  <section id="banner-publicidad" >
    <div class="container">
        <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 text-center text-blanco">
          
        </div>
    </div>
  </section>
  -->

  <!-- Banner Servicios -->
  <section id="banner-servicio" class="parallax">
        <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 text-center text-blanco">
          <h1><b class="text-creativo">CREATIVIDAD </b> <b class="text-idea">IDEA</b> REALIDAD</h1>  
        </div>
  </section>
  
  <!-- Experiencia -->
  <section class="page-section bg-light" id="workExperience" #workExperience>
    <div class="container">
        <div class="text-center">
            <h2 class="section-heading text-uppercase">Experiencia laboral</h2>
            <h3 class="section-subheading text-muted">Lorem ipsum dolor sit amet consectetur.</h3>
        </div>
        <ul class="timeline">
            <li>
                <div class="timeline-image"><img class="img-fluid img-circle" style="top: 40px;" src="assets/img/portfolio/viveTuFuturo.svg" alt="" /></div>
                <div class="timeline-panel">
                    <div class="timeline-heading">
                        <h4>Jun 2018 - Abr 2019</h4>
                        <h4 class="subheading">Vive Tu Futuro</h4>
                    </div>
                    <div class="timeline-body"><p class="text-muted">Sistema de Gestión de experiencias personalizadas y clientes con HTML, CSS, Javascript, Jquery y Vue.</p></div>
                </div>
            </li>
            <li class="timeline-inverted">
                <div class="timeline-image"><img class="img-fluid img-circle" style="top: 25px;" src="assets/img/portfolio/gs.svg" alt="" /></div>
                <div class="timeline-panel">
                    <div class="timeline-heading">
                        <h4>Mar 2020 - Feb 2021</h4>
                        <h4 class="subheading">Grupo Salinas</h4>
                    </div>
                    <div class="timeline-body"><p class="text-muted">Automatizaciones Android y iOS con Appium. Automatizaciones de servicios con java, karate, gatling y scala.</p></div>
                </div>
            </li>   
            <li class="timeline-inverted">
                <div class="timeline-image">
                    <h4 class="text-secondary text-center" style="margin-top: 33px !important;">
                        Continuo
                        <br />
                        aprendiendo,
                        <br />
                        desarrollando!
                    </h4>
                </div>
            </li>
        </ul>
    </div>
  </section>

  <!-- Portfolio Grid -->
  <section class="" id="portfolio">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Portafolio</h2>
          <h3 class="section-subheading text-muted">Proyectos en los que he trabajado he utilizado tecnologías</h3>
        </div>
      </div>
      <!-- Cards of Project -->
      <app-project-card [projects]='projects' (projectSelected)="setProject( $event )"></app-project-card>

    </div>
  </section>

  <!-- Team -->
  <section class="bg-light" id="team">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">¿Quién soy?</h2>
          <!-- <h3 class="section-subheading text-muted">Tenemos diferentes sucursales en el país.</h3> -->
        </div>
      </div>
      <div class="row">
        <div class="col-xs-10 offset-xs-1 col-md-4 offset-md-4">
          <div class="team-member">
            <img class="mx-auto rounded-circle zoom" src="assets/img/team/monterrey.jpg" alt="">
            <h4>Andrés López</h4>
            <p class="text-muted">Developer</p>
            <ul class="list-inline social-buttons">
              <li class="list-inline-item">
                <a href="{{social.github.url}}" class="fab">
                  <i class="devicon-github-original"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a [href]="social.linkedin.url" class="fab">
                  <i class="icon-linkedin2"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 mx-auto text-center">
          <!--<p class="large text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut eaque, laboriosam veritatis, quos non quis ad perspiciatis, totam corporis ea, alias ut unde.</p>-->
        </div>
      </div>
    </div>
  </section>

  <!-- Clientes -->
  <section id="banner-clientes" class="py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Educación</h2>
          <hr>
        </div>
      </div>
      <div id="empresas-logo" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3">
            <i class="icon-couch-surfing"></i>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact -->
  <section id="contact">
    <div class="container text-white">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Contacto</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-4 col-lg-4 contacto pb-4">
          <h5 class="text-white"><i class="icon-phone"></i> Celular/ Whatsapp</h5>
          Móvil: 55-37-00-63-10
        </div>
        <div class="col-sm-12 col-md-4 col-lg-4 contacto pb-4">
          <h5 class="text-white"> <i class="icon-envelop"></i> Correo</h5>
          Email: <a href="mailto:andgvo@gmail.com"> andgvo@gmail.com </a>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-4 text-center">
          <h5 class="text-white"><i class="icon-phone"></i> Redes Sociales</h5>
          <ul class="list-inline social-buttons">
            <li class="list-inline-item">
              <a href="{{social.github.url}}" class="fab">
                <i class="devicon-github-original"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="{{social.linkedin.url}}" class="fab">
                <i class="icon-linkedin2"></i>
              </a>
            </li>
          </ul>
        </div>
            
      </div>
    </div>
  </section>
</div>

<!-- Portfolio Modals -->
<div class="modal fade" id="portfolioModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Project Details Go Here -->
        <h2 id="lbl_nombreProyecto" class="text-uppercase">{{ projectSelected.name }}</h2>
        <p id="lbl_intro" class="item-intro text-muted">{{ projectSelected.category }}</p>
        <img id="img_proyecto" class="img-fluid d-block mx-auto" [src]="projectSelected.image" alt="">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>